// // utils/nodeIndex.js
// export function buildObjectIdIndex(root) {
//   const index = new Map();

//   function visit(n) {
//     if (n._objectId != null) {
//       index.set(n._objectId, n);
//     }
//     (n.children || []).forEach(visit);
//   }

//   if (root) visit(root);
//   return index;
// }

// utils/nodeIndex.js
// Scene nodes (InternalSceneNode) expose their id via the `id` getter.
export function buildObjectIdIndex(root) {
  const index = new Map();

  function visit(n) {
    if (!n) return;
    const id = n.id ?? n._objectId;
    if (id != null) index.set(id, n);
    (n.children || []).forEach(visit);
  }

  visit(root);
  return index;
}